import React from 'react';
import cn from 'classnames';
import { useRouter } from 'next/router';

import { Box } from '@lyearn/ui';

import Header from '../Header';
import SignupForm from './SignupForm';
import { signupRoot } from './styles';

function Signup() {
  const router = useRouter();
  const { redirectPath } = router.query;
  return (
    <Box
      className={cn(
        signupRoot,
        'relative flex h-screen w-screen flex-col items-center overflow-auto',
      )}>
      <Header
        LeftNodeRef="@lyearn/components/Header/BrandInfo"
        RightNode={null}
        RightNodeRef={null}
        centered={true}
        headerStyles={{
          solidBackgroundColor: 'rgba(255, 255, 255, 0.96)',
        }}
        headerType="sticky"
        height="8rem"
        leftNodeProps={{
          isHomepage: true,
        }}
        middleNodeAlign="center"
      />
      <Box className="signup-container mt-20 mb-50 flex flex-shrink-0 flex-col items-center">
        <SignupForm
          redirectPath={redirectPath as string}
          switchToLogin={() =>
            router.push('/login?redirectPath=' + encodeURIComponent((redirectPath as string) || ''))
          }
        />
      </Box>
    </Box>
  );
}

export default Signup;
